import React from "react";

import $ from 'jquery'

function loading(){
    setTimeout(function () {
        $('.loading').fadeToggle();
        // $('html').css('overflow-y','hidden')
      }, 7000);
    //   call();
      
    return(
        <>
        <div className="loading" id="load">
            <div className="inside animate__animated animate__zoomIn">
                <div className="anim">
    <   div className="animation"><span>Loading...</span></div>
    </div>
    </div>
        </div>
        </>
    );
}
export default loading;